module.exports = __webpack_public_path__ + "static/media/green-mail-icon.5735f275.svg";